module.exports = "pegasus/assets/round-knob.png";